import { LoadingIndicator } from '../common/Loading';
import { AuthGlobalStyles } from './AuthGlobalStyles';

export const AuthLoading: React.FC = () => {
  return (
    <>
      <AuthGlobalStyles />
      <LoadingIndicator />
    </>
  );
};
